/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import {noop} from '@benchling/js-utils';
import React from 'react';

import HelpButton from 'help/HelpButton';
import * as modals from 'help/Modals';
import Toast from 'nav/toasts/Toast';
import {ToastType} from 'nav/toasts/ToastConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Chip, {ChipSize} from 'ui-library/chips/Chip';
import ClipboardText from 'ui-library/ClipboardText';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import * as Headers from 'ui-library/Headers';
import AddIcon from 'ui-library/icons/AddIcon';
import HelpIcon from 'ui-library/icons/HelpIcon';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import ChipSelectInput from 'ui-library/inputs/ChipSelectInput';
import EditableTextField from 'ui-library/inputs/EditableTextField';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import TextField from 'ui-library/inputs/TextField';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import {LocalTime, RelativeTime} from 'ui-library/Times';

type State = any;

class ComponentGuidelines extends React.Component<{}, State> {
  override state: State = {checked: false, iconFilter: '', editableTextFieldValue: 'Hello! Hover over me'};

  _handleToggleChecked = (): void => {
    this.setState({checked: !this.state.checked});
  };

  _shouldDisplayIcon = (icon: any): boolean =>
    this.state.iconFilter.length === 0 ||
    icon.toLowerCase().indexOf(this.state.iconFilter.toLowerCase()) !== -1;

  override render(): JSX.Element {
    return (
      <div className="u-padding">
        <Headers.Header1>Components</Headers.Header1>

        <div className="u-spacing-top">
          <Headers.Header2>Buttons</Headers.Header2>
          <div>
            Code: <code>ui-library/buttons/Button.tsx</code>
          </div>
          <div>
            Guidelines: <a href="./buttons">./buttons</a>
          </div>
          <Button buttonStyle={ButtonStyle.PRIMARY} size={ButtonSize.MEDIUM} text="Click Me" />
        </div>

        <div className="u-spacing-top">
          <Headers.Header2>Clipboard Text</Headers.Header2>
          <div>
            Code: <code>ui-library/ClipboardText.js</code>
          </div>
          <div>
            Use <code>ClipboardText</code> to wrap text that you want to be copied to the clipboard!
            <ClipboardText clipboardData="Jeffy P">Click to copy my name!</ClipboardText>
          </div>
        </div>

        <div className="u-spacing-top">
          <Headers.Header2>Headers</Headers.Header2>
          <div>
            Code: <code>ui-library/Headers.js</code>
          </div>
          <div>
            Guidelines: <a href="./headers">./headers</a>
          </div>
          <Headers.Header1>Header 1</Headers.Header1>
          <Headers.Header2>Header 2</Headers.Header2>
          <Headers.Header3>Header 3</Headers.Header3>
        </div>

        <div className="u-spacing-top">
          <Headers.Header2>Help Icon</Headers.Header2>
          <div>
            Code: <code>ui-library/HelpIcon.js</code>
          </div>
          <div>
            Help icons can be wrapped by tooltips and have <code>onClick</code> handlers:
            <Tooltip title="Help me!">
              <HelpIcon className="u-mini-spacing-left" onClick={modals.showPublicHelp} />
            </Tooltip>
          </div>
          <div>
            Use a <code>HelpButton</code> to use popovers:
            <HelpButton renderContent={() => 'I can help you!'} iconClassName="u-mini-spacing-left" />
          </div>
        </div>

        <div className="u-spacing-top">
          <Headers.Header2>Add Icon</Headers.Header2>
          <div>
            Code: <code>ui-library/AddIcon.js</code>
          </div>
          <div>
            Add icons should be used inline and have <code>onClick</code> handlers:
            <Headers.Header3>
              My Things
              <AddIcon onClick={noop} />
            </Headers.Header3>
          </div>
        </div>

        <div className="u-spacing-top">
          <Headers.Header2>Chips</Headers.Header2>
          <div>
            Code: <code>ui-library/chips/</code>
          </div>
          <div>
            Guidelines: <a href="./chips">./chips</a>
          </div>
          <Chip size={ChipSize.SMALL} text="pBR322" icon={FolderItemIcon.Sequence} />
        </div>

        <div className="u-spacing-top">
          <Headers.Header2>Field Inputs</Headers.Header2>
          <div>
            Code: <code>ui-library/inputs/</code>
          </div>
          <div>
            Guidelines: <a href="./field-inputs">./field-inputs</a>
          </div>
          <div style={{width: '300px'}}>
            <TextField
              placeholder="Watermark"
              label="Label"
              labelStyle={FieldLabel.STYLES.LABEL}
              button={<Button buttonStyle={ButtonStyle.SECONDARY} size={ButtonSize.SMALL} text="CTA" />}
            />
          </div>
          <div className="u-small-spacing-top">
            <CheckboxInput
              checked={this.state.checked}
              label="Checkbox input"
              onChange={this._handleToggleChecked}
              id="checkbox-a"
            />
          </div>
          <div style={{width: '300px'}} className="u-small-spacing-top">
            <Headers.Header3>Editable Text Field</Headers.Header3>
            <EditableTextField
              isDisabled={false}
              requestChange={(newVal) => {
                this.setState({editableTextFieldValue: newVal});
              }}
              value={this.state.editableTextFieldValue}
            />
            <div>
              Code: <code>ui-library/inputs/EditableTextField.tsx</code>
            </div>
          </div>
        </div>

        <div className="u-spacing-top">
          <Headers.Header2>Dropdowns</Headers.Header2>
          <div>
            Code: <code>ui-library/dropdowns/</code>, <code>ui-library/menus/</code>
          </div>
          <div>
            Guidelines: <a href="./dropdowns">./dropdowns</a>
          </div>
          <div>
            <Dropdown
              menu={
                <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.SMALL}>
                  <Option value={1}>Option 1</Option>
                  <Option value={2}>Option 2</Option>
                  <Option value={3}>
                    Option 3
                    <Menu>
                      <Option value={4}>Option 4</Option>
                      <Option value={5}>Option 5</Option>
                    </Menu>
                  </Option>
                </Menu>
              }
            >
              <Button
                buttonStyle={ButtonStyle.PRIMARY}
                isDropdown={true}
                size={ButtonSize.MEDIUM}
                text="Pick an Option!"
              />
            </Dropdown>
          </div>
        </div>

        <div className="u-spacing-top">
          <Headers.Header2>Select Inputs</Headers.Header2>
          <div>
            Code: <code>ui-library/inputs/</code>
          </div>
          <div>
            Guidelines: <a href="./select-inputs">./select-inputs</a>
          </div>
          <div style={{width: '300px'}}>
            <ChipSelectInput
              placeholder="Type something..."
              optionDatas={[
                {name: 'Option 1', value: 'Option 1'},
                {name: 'Option 2', value: 'Option 2'},
                {name: 'Option 3', value: 'Option 3'},
              ]}
              value={['Option 1', 'Option 3']}
            />
          </div>
        </div>

        <div className="u-spacing-top">
          <Headers.Header2>Filter Forms</Headers.Header2>
          <div>
            Code: <code>search/filters/</code>
          </div>
          <div>
            Guidelines: <a href="./filter-forms">./filter-forms</a>
          </div>
        </div>

        <div className="u-spacing-top">
          <Headers.Header2>Toasts</Headers.Header2>
          <div>
            Code: <code>nav/toasts/Toast.js</code>
          </div>
          <div>
            Guidelines: <a href="./toasts">./toasts</a>
          </div>
          {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'isCloseable' is missing in type '{ messa... Remove this comment to see the full error message */}
          <Toast
            message="A newer version of Benchling is available."
            actionText="Refresh"
            onActionClick={noop}
            id="refresh"
            type={ToastType.INFO}
          />
        </div>

        <div className="u-spacing-top">
          <Headers.Header2>Times</Headers.Header2>
          <div>
            Code: <code>ui-library/Times.js</code>
          </div>
          <div className="u-small-spacing-top">
            <Headers.Sublabel>RelativeTime</Headers.Sublabel>
            <RelativeTime datetime="2017-11-07T22:23:07.888Z" />
          </div>
          <div className="u-small-spacing-top">
            <Headers.Sublabel>LocalTime</Headers.Sublabel>
            <LocalTime datetime="2017-11-07T22:23:07.888Z" />
          </div>
        </div>
      </div>
    );
  }
}

export default ComponentGuidelines;
